import { default as OLZoomToExtent } from 'ol/control/ZoomToExtent';
import { default as RControlBase } from './RControlBase';
export default class RZoomToExtent extends RControlBase {
    constructor(props) {
        super(props);
        this.ol = new OLZoomToExtent(this.toOLProps(props));
    }
    toOLProps(props) {
        return Object.assign(Object.assign({}, super.toOLProps(props)), { extent: props.extent, label: props.label, tipLabel: props.tipLabel });
    }
}
//# sourceMappingURL=RZoomToExtent.js.map